import { useMemo, useContext } from "react";
import {
    useDigitalMenuConfig,
    DigitalMenuVersion,
    SwiggyContextHeader,
    hasMinimumPlVersion,
} from "@swiggy-private/portal-dineout-context";
import { isApp } from "../utils/browser";

/**
 * Hook to check if the app is running V2 digital menu in native app with minimum pl-version requirement
 * @returns { isV2: boolean; isV2InApp: boolean } true if all conditions are met: isApp() && config.version === V2 && pl-version >= 124
 */
export const useIsV2InApp = (): { isV2: boolean; isV2InApp: boolean } => {
    const { config } = useDigitalMenuConfig();
    const { swiggyHeaders } = useContext(SwiggyContextHeader);
    const isV2 = useMemo(() => config?.version === DigitalMenuVersion.V2, [config?.version]);

    const isV2InApp = useMemo(() => {
        // Must be in native app
        if (!isApp()) {
            return false;
        }

        // Config must be V2
        if (config?.version !== DigitalMenuVersion.V2) {
            return false;
        }

        // Check pl-version meets minimum requirement
        if (!hasMinimumPlVersion(swiggyHeaders)) {
            return false;
        }

        return true;
    }, [config, swiggyHeaders]);

    return { isV2, isV2InApp };
};
